import type { NoAccessPageDE } from "../de/de.noAccessPage";

export const NoAccessPageEN: typeof NoAccessPageDE = {
  title: "You shall not pass!",
  subtitle:
    "Sorry, you are not authorised to view this page. Please contact <0>customer service</0> if you would like to access this page.",
  button: "Visit heo shop",
  mailSubject: "Request access to Business Console",
};
